import { useCallback } from "react";
import { createFileRoute } from "@tanstack/react-router";

import Chatbot from "../pages/Chatbot";
import {
  DEFAULT_SETTINGS_TAB,
  parseSettingsTab,
  type SettingsTab,
} from "../pages/Chatbot/utils/settingsTabs";
import { RequireAuth } from "../utils/RequireAuth";

function parseChatbotSearch(search: Record<string, unknown>): { tab?: SettingsTab } {
  const tab = parseSettingsTab(search.tab);
  return tab ? { tab } : {};
}

// App.jsx folded the chatbot-access check into ProtectedRoute's
// isAuthenticated, which sent authenticated users without access to /login.
// RequireAuth require="chatbotAccess" sends them to "/" instead — an
// intentional fix of that /login bounce.
export const Route = createFileRoute("/_shell/chatbot")({
  validateSearch: (search: Record<string, unknown>) => parseChatbotSearch(search),
  component: ChatbotRoute,
});

function ChatbotRoute() {
  const { tab } = Route.useSearch();
  const navigate = Route.useNavigate();
  // Keep `?tab=` in step with the selected tab so reload and back/forward reopen it.
  const handleSettingsTabChange = useCallback(
    (next: SettingsTab) => {
      void navigate({
        search: (prev) => ({ ...prev, tab: next === DEFAULT_SETTINGS_TAB ? undefined : next }),
        replace: true,
      });
    },
    [navigate],
  );

  return (
    <RequireAuth require="chatbotAccess" page="chatbot">
      <Chatbot settingsTab={tab} onSettingsTabChange={handleSettingsTabChange} />
    </RequireAuth>
  );
}
